import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.array.sort.js";
import { getInteractionCount } from './polyfills/interactionCountPolyfill.js';

/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
var MAX_INTERACTIONS_TO_CONSIDER = 10;

// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
var prevInteractionCount = 0;

/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */
var getInteractionCountForNavigation = function getInteractionCountForNavigation() {
  return getInteractionCount() - prevInteractionCount;
};

/**
 *
 */
var InteractionManager = /*#__PURE__*/function () {
  function InteractionManager() {
    _classCallCheck(this, InteractionManager);
    InteractionManager.prototype.__init.call(this);
    InteractionManager.prototype.__init2.call(this);
  }
  /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  return _createClass(InteractionManager, [{
    key: "__init",
    value: function __init() {
      this._longestInteractionList = [];
    }

    /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */
    // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  }, {
    key: "__init2",
    value: function __init2() {
      this._longestInteractionMap = new Map();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  }, {
    key: "_resetInteractions",
    value: function _resetInteractions() {
      prevInteractionCount = getInteractionCount();
      this._longestInteractionList.length = 0;
      this._longestInteractionMap.clear();
    }

    /**
     * Returns the estimated p98 longest interaction based on the stored
     * interaction candidates and the interaction count for the current page.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  }, {
    key: "_estimateP98LongestInteraction",
    value: function _estimateP98LongestInteraction() {
      var candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor(getInteractionCountForNavigation() / 50));
      return this._longestInteractionList[candidateInteractionIndex];
    }

    /**
     * Takes a performance entry and adds it to the list of worst interactions
     * if its duration is long enough to make it among the worst. If the
     * entry is part of an existing interaction, it is merged and the latency
     * and entries list is updated as needed.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  }, {
    key: "_processEntry",
    value: function _processEntry(entry) {
      var _this$_onBeforeProces;
      (_this$_onBeforeProces = this._onBeforeProcessingEntry) === null || _this$_onBeforeProces === void 0 || _this$_onBeforeProces.call(this, entry);

      // Skip further processing for entries that cannot be INP candidates.
      if (!(entry.interactionId || entry.entryType === 'first-input')) return;

      // The least-long of the 10 longest interactions.
      var minLongestInteraction = this._longestInteractionList.at(-1);
      var interaction = this._longestInteractionMap.get(entry.interactionId);

      // Only process the entry if it's possibly one of the ten longest,
      // or if it's part of an existing interaction.
      if (interaction || this._longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER ||
      // If the above conditions are false, `minLongestInteraction` will be set.
      entry.duration > minLongestInteraction._latency) {
        var _this$_onAfterProcess;
        // If the interaction already exists, update it. Otherwise create one.
        if (interaction) {
          // If the new entry has a longer duration, replace the old entries,
          // otherwise add to the array.
          if (entry.duration > interaction._latency) {
            interaction.entries = [entry];
            interaction._latency = entry.duration;
          } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) {
            interaction.entries.push(entry);
          }
        } else {
          interaction = {
            id: entry.interactionId,
            entries: [entry],
            _latency: entry.duration
          };
          this._longestInteractionMap.set(interaction.id, interaction);
          this._longestInteractionList.push(interaction);
        }

        // Sort the entries by latency (descending) and keep only the top ten.
        this._longestInteractionList.sort(function (a, b) {
          return b._latency - a._latency;
        });
        if (this._longestInteractionList.length > MAX_INTERACTIONS_TO_CONSIDER) {
          var removedInteractions = this._longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER);
          var _iterator = _createForOfIteratorHelper(removedInteractions),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _interaction = _step.value;
              this._longestInteractionMap.delete(_interaction.id);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        // Call any post-processing on the interaction
        (_this$_onAfterProcess = this._onAfterProcessingINPCandidate) === null || _this$_onAfterProcess === void 0 || _this$_onAfterProcess.call(this, interaction);
      }
    }
  }]);
}();
export { InteractionManager };